module.exports = __webpack_public_path__ + "static/media/bike transport service from hyderabad.b59b72b9.jpg";